const jpStates = [
    { name: "東京都", code: "Tokyo" },
    { name: "北海道", code: "Hokkaido" },
    { name: "大阪府", code: "Osaka" },
    { name: "京都府", code: "Kyoto" },
    { name: "青森県", code: "Aomori" },
    { name: "秋田県", code: "Akita" },
    { name: "石川県", code: "Ishikawa" },
    { name: "茨城県", code: "Ibaraki" },
    { name: "岩手県", code: "Iwate" },
    { name: "愛媛県", code: "Ehime" },
    { name: "大分県", code: "Oita" },
    { name: "岡山県", code: "Okayama" },
    { name: "沖縄県", code: "Okinawa" },
    { name: "香川県", code: "Kagawa" },
    { name: "鹿児島県", code: "Kagoshima" },
    { name: "神奈川県", code: "Kanagawa" },
    { name: "岐阜県", code: "Gifu" },
    { name: "熊本県", code: "Kumamoto" },
    { name: "群馬県", code: "Gunma" },
    { name: "高知県", code: "Kochi" },
    { name: "埼玉県", code: "Saitama" },
    { name: "佐賀県", code: "Saga" },
    { name: "滋賀県", code: "Shiga" },
    { name: "静岡県", code: "Shizuoka" },
    { name: "島根県", code: "Shimane" },
    { name: "千葉県", code: "Chiba" },
    { name: "愛知県", code: "Aichi" },
    { name: "栃木県", code: "Tochigi" },
    { name: "富山県", code: "Toyama" },
    { name: "長崎県", code: "Nagasaki" },
    { name: "奈良県", code: "Nara" },
    { name: "新潟県", code: "Niigata" },
    { name: "兵庫県", code: "Hyogo" },
    { name: "広島県", code: "Hiroshima" },
    { name: "福井県", code: "Fukui" },
    { name: "福岡県", code: "Fukuoka" },
    { name: "福島県", code: "Fukushima" },
    { name: "三重県", code: "Mie" },
    { name: "宮城県", code: "Miyagi" },
    { name: "宮崎県", code: "Miyazaki" },
    { name: "山形県", code: "Yamagata" },
    { name: "山口県", code: "Yamaguchi" },
    { name: "山梨県", code: "Yamanashi" },
    { name: "和歌山県", code: "Wakayama" },
]
export default jpStates;